<template>
  <v-container class="mt-4 ml-2" fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="shadowCard reporte-card">
          <div class="reporte-head">
            <div>
              <div class="text-h6 mb-0">Reporte de contactos</div>
              <div class="text-caption grey--text text--darken-1">
                Último mensaje en el rango. El mínimo cuenta lo que escribió el contacto.
              </div>
            </div>
            <div class="reporte-acciones">
              <v-btn
                color="green darken-2"
                dark
                small
                rounded
                class="text-capitalize"
                :disabled="!hayFilas || cargando"
                @click="descargarExcel"
              >
                <v-icon left small>mdi-microsoft-excel</v-icon>
                Excel
              </v-btn>
              <v-btn
                color="primary"
                dark
                small
                rounded
                class="text-capitalize"
                :loading="cargando"
                :disabled="cargando"
                @click="consultar"
              >
                <v-icon left small>mdi-refresh</v-icon>
                Actualizar
              </v-btn>
            </div>
          </div>
          <v-progress-linear
            v-if="cargando"
            indeterminate
            color="primary"
            height="4"
          />

          <v-card-text class="pt-4">
            <div class="filtros">
              <v-row dense>
                <v-col cols="12" sm="6" md="3" lg="2">
                  <v-text-field v-model="desde" label="Desde" type="date" filled dense hide-details :disabled="cargando" />
                </v-col>
                <v-col cols="12" sm="6" md="3" lg="2">
                  <v-text-field v-model="hasta" label="Hasta" type="date" filled dense hide-details :disabled="cargando" />
                </v-col>
                <v-col cols="12" sm="6" md="3" lg="2">
                  <v-select
                    v-model="escuela"
                    :items="escuelas"
                    item-text="text"
                    item-value="value"
                    label="Escuela"
                    filled
                    dense
                    hide-details
                    :disabled="cargando"
                    @change="alCambiarEscuela"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="3" lg="3">
                  <v-select
                    v-model="telefonos"
                    :items="telefonosVisibles"
                    item-text="text"
                    item-value="bd"
                    label="Teléfono"
                    multiple
                    chips
                    small-chips
                    deletable-chips
                    filled
                    dense
                    hide-details
                    :disabled="cargando"
                  />
                </v-col>
                <v-col cols="12" md="6" lg="3">
                  <v-select
                    v-model="etiquetas"
                    :items="catalogo"
                    item-text="etiqueta"
                    item-value="idetiquetas"
                    label="Etiqueta"
                    multiple
                    chips
                    small-chips
                    deletable-chips
                    clearable
                    filled
                    dense
                    hide-details
                    :disabled="cargando"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="3" lg="2">
                  <v-select
                    v-model="ventana"
                    :items="opcionesVentana"
                    item-text="text"
                    item-value="value"
                    label="Ventana"
                    filled
                    dense
                    hide-details
                    :disabled="cargando"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="3" lg="2">
                  <v-select
                    v-model="inscrito"
                    :items="opcionesInscrito"
                    item-text="text"
                    item-value="value"
                    label="Inscrito"
                    filled
                    dense
                    hide-details
                    :disabled="cargando"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="3" lg="2">
                  <v-text-field
                    v-model.number="minMensajes"
                    label="Mínimo de mensajes"
                    type="number"
                    min="0"
                    filled
                    dense
                    hide-details
                    :disabled="cargando"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="3" lg="2" class="d-flex align-center">
                  <v-switch v-model="quitarSpam" label="Quitar SPAM" dense hide-details class="mt-0" :disabled="cargando" />
                </v-col>
              </v-row>
            </div>

            <div v-if="cargando" class="estado-carga">
              <v-progress-circular indeterminate color="primary" size="54" width="5" />
              <div class="text-subtitle-1 font-weight-medium mt-4">Armando el reporte</div>
              <div class="text-body-2 grey--text text--darken-1 mt-1">
                Está consultando los teléfonos. Puede tardar unos segundos.
              </div>
            </div>

            <div v-else-if="!bloques.length" class="estado-vacio">
              Pulsa Actualizar para armar el reporte.
            </div>

            <v-row v-else class="mt-2">
              <v-col
                v-for="bloque in bloques"
                :key="bloque.escuela"
                cols="12"
                :lg="anchoBloque(bloque)"
              >
                <div class="bloque">
                  <div class="bloque-head" :class="bloque.escuela === 'FAST' ? 'bloque-head--fast' : 'bloque-head--inbi'">
                    <div>
                      <div class="bloque-escuela">{{ bloque.escuela }}</div>
                      <div class="bloque-titulo">{{ titulo }}</div>
                    </div>
                    <div class="bloque-cifra">
                      <div class="bloque-cifra__num">{{ bloque.total }}</div>
                      <div class="bloque-cifra__lbl">contactos</div>
                    </div>
                  </div>

                  <div v-if="bloque.filas.length" class="tabla-wrap">
                    <table class="reporte-tabla">
                      <thead>
                        <tr>
                          <th class="text-left">Etiqueta</th>
                          <th v-for="col in bloque.columnas" :key="col" class="text-right">{{ col }}</th>
                          <th class="text-right">Total</th>
                          <th class="text-right">Mensajes</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="fila in bloque.filas" :key="bloque.escuela + fila.etiqueta">
                          <td class="etiqueta-nombre">{{ fila.etiqueta }}</td>
                          <td v-for="(valor, indice) in fila.celdas" :key="indice" class="text-right num">{{ valor }}</td>
                          <td class="text-right num font-weight-medium">{{ fila.total }}</td>
                          <td class="text-right num">{{ fila.mensajes }}</td>
                        </tr>
                        <tr class="fila-total">
                          <td>TOTAL</td>
                          <td v-for="(valor, indice) in bloque.totales" :key="'t' + indice" class="text-right num">{{ valor }}</td>
                          <td class="text-right num">{{ bloque.total }}</td>
                          <td class="text-right num">{{ bloque.mensajes }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div v-else class="estado-vacio">
                    Sin contactos con estos filtros.
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <Alerta v-if="respuestaAlerta" :parametros="parametros" />
  </v-container>
</template>

<script>
import XLSX from 'xlsx'
import Alerta from '@/components/alertas/Alerta.vue'
import validarErrores from '@/mixins/validarErrores'

const TELEFONOS = [
  { bd: '5213316971156', escuela: 1, text: 'INBI Guadalajara', columna: 'GDL' },
  { bd: '5215545703336', escuela: 1, text: 'INBI CDMX', columna: 'CDMX' },
  { bd: '5218187047279', escuela: 1, text: 'INBI Monterrey', columna: 'MTY' },
  { bd: '5218123255321', escuela: 2, text: 'FAST', columna: 'FAST' },
]

function ymd (fecha) {
  const mes = String(fecha.getMonth() + 1).padStart(2, '0')
  const dia = String(fecha.getDate()).padStart(2, '0')
  return fecha.getFullYear() + '-' + mes + '-' + dia
}

export default {
  components: { Alerta },
  mixins: [validarErrores],

  data () {
    const hoy = new Date()
    const inicio = new Date(hoy.getFullYear(), hoy.getMonth(), 1)
    return {
      desde: ymd(inicio),
      hasta: ymd(hoy),
      escuela: 0,
      telefonos: TELEFONOS.map((t) => t.bd),
      etiquetas: [],
      ventana: 'todas',
      inscrito: 'no',
      minMensajes: 4,
      quitarSpam: true,
      catalogo: [],
      titulo: '',
      bloques: [],
      cargando: false,
      escuelas: [
        { text: 'Todas', value: 0 },
        { text: 'INBI', value: 1 },
        { text: 'FAST', value: 2 },
      ],
      opcionesVentana: [
        { text: 'Todas', value: 'todas' },
        { text: 'Abierta', value: 'abierta' },
        { text: 'Cerrada', value: 'cerrada' },
      ],
      opcionesInscrito: [
        { text: 'No inscritos', value: 'no' },
        { text: 'Inscritos', value: 'si' },
        { text: 'Todos', value: 'todos' },
      ],
    }
  },

  computed: {
    telefonosVisibles () {
      if (this.escuela === 1 || this.escuela === 2) {
        return TELEFONOS.filter((t) => t.escuela === this.escuela)
      }
      return TELEFONOS
    },

    hayFilas () {
      for (let i = 0; i < this.bloques.length; i++) {
        if (this.bloques[i].filas && this.bloques[i].filas.length) return true
      }
      return false
    },
  },

  created () {
    this.cargarEtiquetas()
    this.consultar()
  },

  beforeDestroy () {
    this.cerrarLoader()
  },

  methods: {
    anchoBloque (bloque) {
      if (this.bloques.length < 2) return 12
      return bloque.escuela === 'FAST' ? 4 : 8
    },

    alCambiarEscuela () {
      const visibles = this.telefonosVisibles.map((t) => t.bd)
      this.telefonos = visibles
    },

    cargarEtiquetas () {
      this.$http.get('twilio.etiquetas').then((response) => {
        this.catalogo = response.data || []
      }).catch((error) => {
        this.validarError(error)
      })
    },

    abrirLoader () {
      this.cerrarLoader()
      if (!document.getElementById('reporte-giro-style')) {
        const estilo = document.createElement('style')
        estilo.id = 'reporte-giro-style'
        estilo.textContent = '@keyframes reporteGiro{to{transform:rotate(360deg)}}'
        document.head.appendChild(estilo)
      }
      const el = document.createElement('div')
      el.id = 'reporte-contactos-loader'
      el.setAttribute('style', 'position:fixed;top:0;right:0;bottom:0;left:0;z-index:30000;background:rgba(15,23,42,.55);display:flex;align-items:center;justify-content:center;')
      el.innerHTML = '<div style="background:#fff;border-radius:16px;padding:28px 36px;text-align:center;min-width:280px;box-shadow:0 16px 40px rgba(0,0,0,.28);font-family:Roboto,sans-serif;">'
        + '<div style="width:48px;height:48px;margin:0 auto 14px;border:4px solid #e5e7eb;border-top-color:#1565c0;border-radius:50%;animation:reporteGiro .8s linear infinite;"></div>'
        + '<div style="font-size:18px;font-weight:700;color:#111;">Armando el reporte</div>'
        + '<div style="margin-top:6px;font-size:14px;color:#667;">Consultando los teléfonos. Espera un momento.</div>'
        + '</div>'
      document.body.appendChild(el)
      this._loaderEl = el
    },

    cerrarLoader () {
      const el = this._loaderEl || document.getElementById('reporte-contactos-loader')
      if (el && el.parentNode) el.parentNode.removeChild(el)
      this._loaderEl = null
    },

    consultar () {
      if (!this.desde || !this.hasta) {
        this.validarError('Indica el rango de fechas')
        return
      }
      const lineas = this.telefonos.length
        ? this.telefonos
        : this.telefonosVisibles.map((t) => t.bd)
      this.cargando = true
      this.abrirLoader()
      this.bloques = []
      this.$http.post('twilio.reporte.contactos', {
        desde: this.desde,
        hasta: this.hasta,
        escuela: this.escuela,
        lineas,
        etiquetas: this.etiquetas || [],
        ventana: this.ventana,
        inscrito: this.inscrito,
        minMensajes: this.minMensajes,
        quitarSpam: this.quitarSpam,
      }).then((response) => {
        const data = response.data || {}
        this.titulo = data.titulo || ''
        this.bloques = data.bloques || []
        this.cargando = false
        this.cerrarLoader()
      }).catch((error) => {
        this.cargando = false
        this.cerrarLoader()
        this.validarError(error)
      })
    },

    descargarExcel () {
      const hoja = []
      for (let b = 0; b < this.bloques.length; b++) {
        const bloque = this.bloques[b]
        hoja.push([this.titulo])
        hoja.push(['etiqueta'].concat(bloque.columnas).concat(['TOTAL', 'Mensajes']))
        for (let f = 0; f < bloque.filas.length; f++) {
          const fila = bloque.filas[f]
          hoja.push([fila.etiqueta].concat(fila.celdas).concat([fila.total, fila.mensajes]))
        }
        hoja.push(['TOTAL'].concat(bloque.totales).concat([bloque.total, bloque.mensajes]))
        hoja.push([])
      }
      const libro = XLSX.utils.book_new()
      const sheet = XLSX.utils.aoa_to_sheet(hoja)
      XLSX.utils.book_append_sheet(libro, sheet, 'Reporte')
      XLSX.writeFile(libro, 'reporte-contactos-' + this.desde + '-a-' + this.hasta + '.xlsx')
    },
  },
}
</script>

<style scoped>
.reporte-card {
  overflow: visible;
}
.reporte-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 18px 20px 14px;
  flex-wrap: wrap;
}
.reporte-acciones {
  display: flex;
  gap: 8px;
}
.filtros {
  background: #f6f7fb;
  border: 1px solid #e7e9f0;
  border-radius: 12px;
  padding: 12px 8px 4px;
}
.estado-carga,
.estado-vacio {
  min-height: 220px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #6b7280;
  padding: 28px 16px;
}
.bloque {
  border: 1px solid #e6e8ee;
  border-radius: 12px;
  background: #fff;
}
.bloque-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  color: #fff;
}
.bloque-head--inbi { background: #1565c0; }
.bloque-head--fast { background: #ef6c00; }
.bloque-escuela {
  font-size: 12px;
  letter-spacing: .06em;
  text-transform: uppercase;
  opacity: .85;
}
.bloque-titulo {
  font-size: 16px;
  font-weight: 700;
}
.bloque-cifra {
  text-align: right;
}
.bloque-cifra__num {
  font-size: 26px;
  font-weight: 700;
  line-height: 1;
}
.bloque-cifra__lbl {
  font-size: 11px;
  opacity: .85;
}
.tabla-wrap {
  overflow-x: auto;
}
.reporte-tabla {
  width: 100%;
  border-collapse: collapse;
}
.reporte-tabla th,
.reporte-tabla td {
  padding: 8px 12px;
  border-bottom: 1px solid #eef0f4;
  font-size: 13px;
  color: #1f2937;
}
.reporte-tabla th {
  font-size: 11px;
  letter-spacing: .04em;
  text-transform: uppercase;
  color: #667085;
  background: #fafbfc;
  font-weight: 700;
}
.etiqueta-nombre {
  font-weight: 600;
  color: #1f2937;
}
.num {
  font-variant-numeric: tabular-nums;
}
.fila-total td {
  background: #e5f6ea;
  font-weight: 700;
  color: #146c2e;
}
</style>
